import type { MediaBlock } from "../../types";
import { Tag } from "../ui/Tag";
import { assetUrl, siteUrl } from "../../wordpress";

/** Bloco editorial: imagem sangrada com faixa branca de texto embaixo. */
export function MediaBlockCard({ block }: { block: MediaBlock }) {
	return (
		<a className="block-link" href={siteUrl(block.href)}>
			<article
				className="block block--media"
				style={{ backgroundImage: `url(${assetUrl(block.image)})` }}
			>
				{block.tag && <Tag>{block.tag}</Tag>}
				<div className="block__content block__content--solid">
					<h3>{block.title}</h3>
					<p className="block__description">{block.description}</p>
					<p className="block__meta">
						<span className="underline">{block.category}</span> / {block.genre}
					</p>
				</div>
			</article>
		</a>
	);
}
